import React, { useState } from "react";

const MdpProtection = ({ children }) => {
  const [inputmdp, setInputmdp] = useState("");
  const [isconnect, setIsconnect] = useState(false);

  // ⚠️ Ici le mot de passe est en dur → visible dans le code build
  const PASSWORD = "pizzle";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputmdp === PASSWORD) {
      setIsconnect(true);
    } else {
      alert("Mot de passe incorrect");
    }
  };

  if (!isconnect) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Accès protégé</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Entrez le mot de passe"
            value={inputmdp}
            onChange={(e) => setInputmdp(e.target.value)}
          />
          <button type="submit">Entrer</button>
        </form>
      </div>
    );
  }

  return <div>{children}</div>;
};

export default MdpProtection;
